

var _installmentPlanTerms = _interopRequireDefault(require("./installmentPlanTerms"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
module.exports = {
  getItemName: _installmentPlanTerms["default"].getItemName,
  getInstallmentPlanData: _installmentPlanTerms["default"].getInstallmentPlanData
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/installmentplan-terms/index.js
// module id = ../node_modules/xo-page-components/src/installmentplan-terms/index.js
// module chunks = 0